import { insertNodeAround } from '../modules/utilities.js'
import { setAllToMaxHeight } from '../modules/setAllToMaxHeight.js'
import Glide from '@glidejs/glide'
import '@glidejs/glide/dist/css/glide.core.min.css'
import { attachClampByQuery } from '../modules/clamp.js'

export const newsMobileOrchestrator = () => {
   // Carrousel News
   mediaMobileGlideInit()

   //launch the clamp library on all the elements which need to limit the number of text visible
   document.querySelectorAll('#newsFilInfo [data-clamp-line]').forEach((elmt) => {
      elmt.addEventListener('end.clamp', () => {
         insertNodeAround(elmt, ' - ', "<span class='title-cat mb-0'><strong>", '</strong></span>')
      })
   })
}

/**
 * Initialise media slider Glide SMARTPHONE
 */
const mediaMobileGlideInit = () => {
   const slidersMobile = []
   let glideOption = {
      gap: 0,
      animationDuration: 200,
      autoplay: 10000,
   }

   document.querySelectorAll('.glide-slider').forEach((slider) => {
      let glideSlider = new Glide(slider, glideOption)

      // Callback after mount
      glideSlider.on('mount.after', () => {
         attachClampByQuery('.o-media-mobile [data-clamp-line]')
         setAllToMaxHeight('.o-media-mobile .js-news-thumb [data-clamp-line]')
      })

      glideSlider.mount()
      slidersMobile.push(glideSlider)
      glideSlider.pause()

      // Déclenchement des sliders suivant l'ordre défini
      const mediaSliderOrder = ['o-news-actu', 'o-news-media1', 'o-news-sport', 'o-news-media2']
      mediaSliderOrder.forEach((sliderName, index) => {
         let startTime = (index + 1) * 2000
         setTimeout(() => {
            if (glideSlider.selector.classList.contains(sliderName)) {
               glideSlider.go('>')
               glideSlider.play()
            }
         }, startTime)
      })
   })
   window.mediaSliders = slidersMobile
}
